var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "url(#paint0_linear_1120_871)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 22.8182C26.0172 22.8182 27.0115 22.5303 27.8572 21.9909C28.703 21.4514 29.3621 20.6847 29.7514 19.7877C30.1406 18.8907 30.2425 17.9036 30.044 16.9514C29.8456 15.9991 29.3558 15.1244 28.6365 14.4378C27.9173 13.7513 27.0009 13.2837 26.0033 13.0943C25.0057 12.9049 23.9716 13.0021 23.0319 13.3737C22.0922 13.7452 21.289 14.3745 20.7239 15.1817C20.1588 15.989 19.8571 16.9382 19.8571 17.9091C19.8571 19.2111 20.399 20.4597 21.3635 21.3803C22.3279 22.301 23.636 22.8182 25 22.8182ZM32.7143 35.0909C33.0553 35.0909 33.3823 34.9616 33.6234 34.7314C33.8645 34.5013 34 34.1891 34 33.8636C34 31.5852 33.0518 29.4001 31.364 27.7889C29.6761 26.1778 27.3869 25.2727 25 25.2727C22.6131 25.2727 20.3239 26.1778 18.636 27.7889C16.9482 29.4001 16 31.5852 16 33.8636C16 34.1891 16.1355 34.5013 16.3766 34.7314C16.6177 34.9616 16.9447 35.0909 17.2857 35.0909H32.7143Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1120_871",
    x1: 25,
    y1: 0,
    x2: 25,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#446DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2F5DFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bfb1afc068e4ab18ecf1fd26cd2eaf6a.svg";
export { ForwardRef as ReactComponent };